// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ScopeSchema } from '../inputTypeSchemas/ScopeSchema'

/////////////////////////////////////////
// EXTERNAL NETWORK DNS ZONE POLICY SCHEMA
/////////////////////////////////////////

export const ExternalNetworkDnsZonePolicySchema = z.object({
  autoScope: ScopeSchema,
  id: z.string(),
  tenantId: z.string(),
  surfaceId: z.string(),
  zoneId: z.string(),
  enabled: z.boolean(),
  recordExclusionPatterns: z.string().array(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ExternalNetworkDnsZonePolicy = z.infer<typeof ExternalNetworkDnsZonePolicySchema>

export default ExternalNetworkDnsZonePolicySchema;
